import { render, staticRenderFns } from "./ToastsDelay.vue?vue&type=template&id=3dfaf156&"
import script from "./ToastsDelay.vue?vue&type=script&lang=js&"
export * from "./ToastsDelay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports